import PlayAnywhere from "../assets/subscription/icon_playanywhere_1x.webp";
import PlayAnywhere2x from "../assets/subscription/icon_playanywhere_2x.webp";
import PlayAnywhere3x from "../assets/subscription/icon_playanywhere_3x.webp";
import VGAIcon from "../assets/subscription/vga_1x.webp";
import VGAIcon2x from "../assets/subscription/vga_2x.webp";
import VGAIcon3x from "../assets/subscription/vga_3x.webp";
import ZeroDownload from "../assets/subscription/0_download_1x.webp";
import ZeroDownload2x from "../assets/subscription/0_download_2x.webp";
import ZeroDownload3x from "../assets/subscription/0_download_3x.webp";
import ReadyIn60s from "../assets/subscription/load_icon_1x.webp";
import ReadyIn60s2x from "../assets/subscription/load_icon_2x.webp";
import ReadyIn60s3x from "../assets/subscription/load_icon_3x.webp";

export enum PaymentStatus {
  SUCCESS = "SUCCESS",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  PENDING = "PENDING",
}

export interface PaymentDialogContent {
  headerKey: string;
  contentKeys: string[];
  mainAction?: {
    textKey: string;
    id: string;
  };
  secondAction?: {
    textKey: string;
    id: string;
  };
}

export const PAYMENT_DIALOG_CONTENT: Record<
  PaymentStatus,
  PaymentDialogContent
> = {
  [PaymentStatus.SUCCESS]: {
    headerKey: "Payment_You're In!",
    contentKeys: [
      "Payment_Your Essential Pass is now active. Your Smart Console is powered up and ready for action.",
    ],
    mainAction: {
      textKey: "Payment_Start Playing",
      id: "start-playing",
    },
  },

  [PaymentStatus.CANCELLED]: {
    headerKey: "Payment_Subscription Not Activated",
    contentKeys: [
      "Payment_It looks like the payment was cancelled. Your Essential Pass is not active yet. Ready to jump back in?",
    ],
    mainAction: {
      textKey: "Payment_Try Again",
      id: "try-again",
    },
    secondAction: {
      textKey: "Payment_Cancel",
      id: "cancel",
    },
  },

  [PaymentStatus.FAILED]: {
    headerKey: "Payment_Payment Unsuccessful",
    contentKeys: [
      "Payment_We couldn't complete your transaction. Please check your details or try a different payment method.",
      "Payment_If any amount was debited from your account, it will be automatically refunded within 5-7 working days.",
    ],
    mainAction: {
      textKey: "Payment_Try Again",
      id: "try-again",
    },
    secondAction: {
      textKey: "Payment_Cancel",
      id: "cancel",
    },
  },

  [PaymentStatus.PENDING]: {
    headerKey: "Payment_Almost There!",
    contentKeys: [
      "Payment_Your payment is being confirmed by the bank. Once successful, your subscription will be automatically activated.",
      "Payment_If the transaction fails, any amount debited will be automatically refunded to your account within 5-7 working days.",
    ],
    mainAction: {
      textKey: "Payment_Ok",
      id: "ok",
    },
  },
};

export const PENDING_POLL_INTERVAL_MS = 5000;

export const SubscribePlanContent = [
  {
    titleKey: "Payment_Play Anywhere",
    descriptionKey: "Payment_Mobile • Desktop • TV",
    icons: {
      "1x": PlayAnywhere,
      "2x": PlayAnywhere2x,
      "3x": PlayAnywhere3x,
    },
  },
  {
    titleKey: "Payment_Better Than Console",
    descriptionKey: "Payment_4K / 60 FPS • Beast-grade servers",
    icons: {
      "1x": VGAIcon,
      "2x": VGAIcon2x,
      "3x": VGAIcon3x,
    },
  },
  {
    titleKey: "Payment_AAA. Zero Downloads.",
    descriptionKey: "Payment_100s of included games • Link your library",
    icons: {
      "1x": ZeroDownload,
      "2x": ZeroDownload2x,
      "3x": ZeroDownload3x,
    },
  },
  {
    titleKey: "Payment_Ready in 60 Seconds",
    descriptionKey: "Payment_Scan, pair & play",
    icons: {
      "1x": ReadyIn60s,
      "2x": ReadyIn60s2x,
      "3x": ReadyIn60s3x,
    },
  },
];
